import { apiInterfaceForJson } from '../common/apiManager';

/**
 * Get recent views for a user
 */
export const getRecentViews = (userId) => {
    return apiInterfaceForJson('/recentViews/find', 'POST', { user_id: userId }).catch((error) => {
        console.error('Error fetching recent views:', error);
        return { data: [] };
    });
};

/**
 * Add a recent view
 * @param {string} userId - User ID
 * @param {string} entityType - Type of entity (order, patient, facility, etc.)
 * @param {string} entityId - Entity ID
 * @param {string} entityLabel - Display label for the entity
 * @param {string} route - Navigation route
 */
export const addRecentView = (userId, entityType, entityId, entityLabel, route) => {
    return apiInterfaceForJson('/recentViews/add', 'POST', {
        user_id: userId,
        entity_type: entityType,
        entity_id: entityId,
        entity_label: entityLabel,
        route: route
    }).catch((error) => {
        console.error('Error adding recent view:', error);
        return { data: [] };
    });
};

/**
 * Helper function to track a recent view using localStorage user ID
 */
export const trackRecentView = (entityType, entityId, entityLabel, route) => {
    const userId = window.localStorage.getItem('USER_ID');
    if (!userId) {
        console.warn('Cannot track recent view: No user ID found');
        return Promise.resolve({ data: [] });
    }
    return addRecentView(userId, entityType, entityId, entityLabel, route);
};

/**
 * Clear all recent views for a user
 */
export const clearRecentViews = (userId) => {
    return apiInterfaceForJson('/recentViews/clear', 'POST', { user_id: userId }).catch((error) => {
        console.error('Error clearing recent views:', error);
        return { data: [] };
    });
};

/**
 * Remove a specific recent view
 */
export const removeRecentView = (userId, entityType, entityId) => {
    return apiInterfaceForJson('/recentViews/remove', 'POST', {
        user_id: userId,
        entity_type: entityType,
        entity_id: entityId
    }).catch((error) => {
        console.error('Error removing recent view:', error);
        return { data: [] };
    });
};

/**
 * Entity type icons mapping
 */
export const entityTypeIcons = {
    order: 'fa-file-medical',
    patient: 'fa-user',
    facility: 'fa-hospital',
    physician: 'fa-user-md',
    invoice: 'fa-file-invoice-dollar',
    company: 'fa-building',
    family: 'fa-users',
    user: 'fa-user-cog',
    test: 'fa-vial',
    analyte: 'fa-flask',
    instrument: 'fa-microscope',
    lab: 'fa-clinic-medical',
    qc_sample: 'fa-check-circle',
    qc_result: 'fa-chart-line',
    qc_range: 'fa-sliders-h',
    qc_report: 'fa-file-chart-line',
    communication: 'fa-comments',
    insurance_provider: 'fa-id-card',
    user_info: 'fa-info-circle'
};

/**
 * Entity type display names
 */
export const entityTypeLabels = {
    order: 'Order',
    patient: 'Patient',
    facility: 'Facility',
    physician: 'Physician',
    invoice: 'Invoice',
    company: 'Company',
    family: 'Family',
    user: 'User',
    test: 'Test',
    analyte: 'Analyte',
    instrument: 'Instrument',
    lab: 'Lab',
    qc_sample: 'QC Sample',
    qc_result: 'QC Result',
    qc_range: 'QC Range',
    qc_report: 'QC Report',
    communication: 'Communication',
    insurance_provider: 'Insurance Provider',
    user_info: 'User Info'
};
